import { render, staticRenderFns } from "./memberLinkageDetail.vue?vue&type=template&id=3e515fbc&lang=pug"
import script from "./memberLinkageDetail.vue?vue&type=script&lang=js"
export * from "./memberLinkageDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports